import { Markdown } from '@cadstrom/sigma-engine-shared';

import { ClauseMarkdownItem } from './clause-reference-markdown-item.js';
import { BasicRemarkPlugin } from './markdown-plugins-utils.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

const definition = Markdown.ClauseReferenceMarkdownDirectiveDefinition;

/**
 * Remark plugin definition for specification clause references such as `:clause[pinout #12]`.
 * Display only: clause references have no shorthand syntax and no editor support.
 */
export const clauseMarkdownItemDefinition: RemarkMarkdownDirectiveDefinition<typeof definition> = {
	allowedAttributes: definition.allowedAttributes,
	directive: BasicRemarkPlugin(definition.directive, definition.nodeTypes, {
		contentPropName: definition.contentAttributeName,
	}),
	item: ClauseMarkdownItem,
};
